const actionCable = require("../vendor/action_cable")

export default actionCable.createConsumer()
